// jQuery(document).ready(function () {
  
// });

jQuery(function() {
	 
     jQuery('.blog-post a.blog-img').matchHeight();
     jQuery('.megamenu-content .mainwrap ul.main-menu li.menu-link ul.dropdown-submenu.mega-menu li.megamenu-li').matchHeight();
     jQuery('.shop-product-wrap .single-product-wrap .product-content h6 a').matchHeight();

  
});

jQuery(document).on('click','.shopping-cart-close', function(){
   jQuery('body').removeClass('hidden'); 
});

jQuery('#navbarContent').click(function() {
     jQuery('html').toggleClass("menu-open");
});

// jQuery(function() {
//     var header = jQuery(".header");
//     jQuery(window).scroll(function() {    
//         var scroll = jQuery(window).scrollTop();
    
//         if (scroll >= 100) {
//             header.removeClass('menu-open').addClass("menu-open");
//         } else {
//             header.removeClass("menu-open").addClass('menu-open');
//         }
//     });
// });

function matchheight() {}